export const site = {
  name: "诱惑吃瓜",
  slogan: "必看围观姿势",
  tagline: "进聊天室蹲后续，群聊上瘾停不下来",
  email: "hello@youhuochigua.example.com",
  describe:
    "诱惑吃瓜聚集了最会吃瓜的一群人：最新进展第一时间同步，热点反转帮你梳理时间线，聊天室里可以边吃边聊，不错过任何精彩后续。",
  stats: [
    { label: "在线围观人数", value: "18,420", icon: "ri-eye-line" },
    { label: "正在进行的瓜线", value: "126", icon: "ri-fire-line" },
    { label: "聊天室房间", value: "42", icon: "ri-chat-smile-2-line" },
    { label: "今日新增讨论", value: "9,671", icon: "ri-chat-3-line" },
  ],
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "热瓜榜", to: "/hot" },
  { label: "聊天室", to: "/chat" },
  { label: "关于我们", to: "/about" },
];

export const watchSteps = [
  {
    step: "01",
    title: "锁定瓜线",
    desc: "在热瓜榜里挑一条正在发酵的话题，点开就能看到完整时间线与最新进展。",
    icon: "ri-crosshair-2-line",
  },
  {
    step: "02",
    title: "读懂前因后果",
    desc: "每条瓜线都配了背景梳理与关键节点，五分钟补齐你错过的那几天。",
    icon: "ri-book-open-line",
  },
  {
    step: "03",
    title: "进聊天室蹲后续",
    desc: "和同好一起等新进展，有人抛料、有人考据，还有人负责整理时间线。",
    icon: "ri-chat-smile-3-line",
  },
  {
    step: "04",
    title: "理性收瓜",
    desc: "反转来了也不慌，我们记录每一次更新，让你笑着把瓜吃完。",
    icon: "ri-shield-check-line",
  },
];

export const testimonials = [
  {
    name: "夜猫子小陈",
    role: "资深吃瓜群众",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20friendly%20young%20person%2C%20amber%20and%20terracotta%20paper%20style%2C%20simple%20background%2C%20no%20text&width=200&height=200&seq=mock-avatar-01&orientation=squarish",
    text: "以前吃瓜都是东一条西一条，现在直接在热度榜蹲，时间线还帮我理好了，爽到不行。",
    rating: 5,
  },
  {
    name: "追更不停的小Y",
    role: "聊天室常驻",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20cheerful%20young%20woman%2C%20coral%20and%20amber%20paper%20style%2C%20simple%20background%2C%20no%20text&width=200&height=200&seq=mock-avatar-02&orientation=squarish",
    text: "聊天室里的人都好会聊，早上蹲一波，晚上再来复盘，反转当天就有人整理，根本停不下来。",
    rating: 5,
  },
  {
    name: "冷静观察员",
    role: "围观礼仪推广者",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20calm%20person%20with%20glasses%2C%20terracotta%20and%20cream%20paper%20style%2C%20simple%20background%2C%20no%20text&width=200&height=200&seq=mock-avatar-03&orientation=squarish",
    text: "喜欢这里的氛围，大家真的会先确认事实再讨论，被带节奏的次数肉眼可见地变少了。",
    rating: 4,
  },
];

export const faqs = [
  {
    q: "「诱惑吃瓜」主要提供什么内容？",
    a: "我们把分散在各大平台的热点整理成一条条完整瓜线，包含背景梳理、关键节点、最新进展与后续追踪，并提供聊天室让同好一起讨论。",
  },
  {
    q: "聊天室需要付费或者注册吗？",
    a: "基础围观与聊天室发言都是免费的。我们更希望你遵守围观礼仪，先看清事实再表达观点，让讨论能够长久进行下去。",
  },
  {
    q: "为什么你们会强调「围观姿势」？",
    a: "因为大多数争议都来自信息不完整时的过度解读。养成先看时间线、再分信息源的习惯，能让你在信息洪流里保持清醒。",
  },
  {
    q: "瓜线更新的速度有多快？",
    a: "热门话题通常在两小时内完成首条整理，出现反转或澄清时会第一时间更新对应条目，并在聊天室同步提醒。",
  },
  {
    q: "如果发现内容有误怎么办？",
    a: "每条瓜线下方都有反馈入口，也可以通过邮箱联系我们。核实之后我们会尽快更正，并保留修订说明。",
  },
];

export const values = [
  {
    icon: "ri-focus-3-line",
    title: "事实优先",
    desc: "先确认时间线，再讨论观点。未证实的说法会明确标注，不与事实混在一起。",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "有料有趣",
    desc: "把行业知识写成人人都能读懂的内容，吃瓜的同时也涨点见识。",
  },
  {
    icon: "ri-heart-3-line",
    title: "友善围观",
    desc: "对事不对人，不点名施压，让每个想聊两句的人都能安心发言。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    desc: "反转不是意外，而是常态。我们追踪到底，也欢迎你一起补充线索。",
  },
];